export default __webpack_public_path__ + "static/media/showerrain.a2671b00.jpg";